import type { FaireProductEntity } from "../../entity_types/product";

export const p_wup2kxwtba: FaireProductEntity = {
  token: "p_wup2kxwtba",
  type: "product",
  name: "Charlie Brown Holiday Decoration Building Kit",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/c4b44eb47e7d895f065d35ddbc1c1b67e6692aa5479fa35e3da93be77f4dd1f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b493f2fcd69a5eefe8bc46bdb3a57f9b528c0539c52f373dc3c4b6db4c5bb61.jpeg",
    "https://cdn.faire.com/fastly/4f908d85d6ecc164e38957adcd5fb2116102f62a4db0d5e13879dbc2e5790bcb.jpeg",
    "https://cdn.faire.com/fastly/bc4d847431255d893aa327e969a5eb1c1fef9e8bb82c5be90816324bbb45e2fb.jpeg",
    "https://cdn.faire.com/fastly/68e5ae79a904fbeffa4e3c8937442051f531ca167dd572380b5818cd7562c5f5.jpeg",
    "https://cdn.faire.com/fastly/f44c0597b4da4a9bbc67674274b5546cf15417a1820fe4dc9952cd2e3259d113.jpeg",
    "https://cdn.faire.com/fastly/8b5daf30e841aa436756f772e767a229dffcf61e7215f633651cca7f361522ec.jpeg",
    "https://cdn.faire.com/fastly/eb30ace0f7b5ca4ead4afd3550c5abd2e49eb311bfa411236bc2e90fd97c31e9.jpeg",
  ],
  priceDollars: 6.89,
  description:
    "Charlie Brown gets a festive makeover in this brick-built holiday decoration, complete with his red Santa hat, cheerful smile, and signature curl of hair. The design features a green scarf and a yellow nameplate base, making him instantly recognizable while adding a seasonal twist. With a sturdy display stand included, this playful build is perfect for showcasing on a shelf, desk, or holiday setup, bringing Peanuts nostalgia into your festive décor.",
  tags: [],
  msrpDollars: 13.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:55.787Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
